module.exports = __webpack_public_path__ + "cdb83332.svg";